import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../store/use-theme";

type Props = { collapsed: boolean };

export default function ThemeToggle({ collapsed }: Props) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div
      className={clsx(
        "border-t border-edge px-3 py-2.5 bg-surface-muted/80 group/theme",
        collapsed && "px-2"
      )}
    >
      <div
        className={clsx(
          "relative flex items-center gap-2.5",
          collapsed ? "justify-center" : "justify-between"
        )}
      >
        {!collapsed && (
          <span className="text-[13px] font-medium text-light-gray">
            Theme
          </span>
        )}
        <button
          type="button"
          role="switch"
          aria-checked={!isDark}
          aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
          onClick={toggleTheme}
          className={clsx(
            "relative inline-flex h-7 w-[3.25rem] shrink-0 items-center rounded-full border border-edge px-0.5 transition-colors duration-300",
            isDark
              ? "bg-slate-900/60"
              : "bg-gradient-to-r from-amber-100 via-amber-50 to-sky-100",
            "hover:border-indigo-400/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/50"
          )}
        >
          <span
            className={clsx(
              "pointer-events-none absolute top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full text-[11px] shadow-md transition-all duration-300 ease-out",
              isDark
                ? "left-0.5 bg-gradient-to-br from-indigo-500 to-violet-600 text-white"
                : "left-[calc(100%-1.625rem)] bg-gradient-to-br from-amber-300 to-orange-400 text-white"
            )}
          >
            <FontAwesomeIcon icon={isDark ? faMoon : faSun} />
          </span>
        </button>
        {collapsed && (
          <span className="pointer-events-none smallLaptop:hidden absolute left-full ml-3 z-50 rounded-lg bg-surface-elevated border border-edge px-3 py-1.5 text-xs text-text-primary shadow-card opacity-0 group-hover/theme:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            Theme
          </span>
        )}
      </div>
    </div>
  );
}
